import React from "react";
import { TbAddressBook, TbBuilding, TbBuildingCommunity, TbCalendarEvent, TbCurrentLocation, TbFileDollar, TbFileText, TbMap2, TbMapPin, TbPencil, TbPhotoPin, TbUserDollar,  TbWorld } from "react-icons/tb";
import { VscPercentage } from "react-icons/vsc";
import {
  Box,
  Button,
  Checkbox,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import { getDateProperFormatForInputFn } from "../../../utils/common";
import useCommonfn from "../../../utils/useCommonfn";
import { Card, CardHeading, OrganizationBx, OrganizationEmDetails } from "../../style";
import { ESI_INPUT_FIELDS } from "./esi-constant";
import useEsiService from "./use-esi-service";
function StatutoryEsi() {
  const { navigateToDashBoard } = useCommonfn();
  const {
    handleDisableAllESIFn,
    handleSubmitFn,
    esiInputs,
    getInputFieldProps = () => {},
    createUpdateLoading,
    stateList,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    viewESIDetails,
    openStatutoryEPFModal,
    handleOpenStatutoryEPFModal,
    handleCloseStatutoryEPFModal,
    openEPFAddressModal,
    handleOpenEPFAddressModal,
    handleCloseEPFAddressModal,
    getStateName,
  } = useEsiService();

  return (
    <>
      {!viewESIDetails?.esi_code ? (
        <>
          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" mb={"0"}>
                {`Employee's State insurance`}
              </Typography>
              <Typography variant="body2" mb={"0"}>
                {`Deduction Circle: Monthly`}
              </Typography>
            </Box>

            <Switchbox
              label={`${esiInputs.isDisableEsi ? "Disable" : "Enable"} ESI`}
              color="Primary"
              size="lg"
              lableFirst
              checked={esiInputs.isDisableEsi}
              onChange={handleDisableAllESIFn}
            />
          </Flex>

          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.esi_code.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.coverage_date.name)}
                valueSinc
                onKeyDown={(e) => e.preventDefault()}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(
                  ESI_INPUT_FIELDS.employee_contribution.name
                )}
                valueSinc
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldProps(
                  ESI_INPUT_FIELDS.employer_contribution.name
                )}
                valueSinc
              />
            </Col>
          </Row>

          <Divider gap={20} />

          <Typography variant="h5">ESI Address</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.esi_office.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.address.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.city.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.state.name)}
                options={stateList || []}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.country.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.pincode.name)}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                disabled={!esiInputs?.isDisableEsi}
                {...getInputFieldProps(ESI_INPUT_FIELDS.location.name)}
              />
            </Col>
          </Row>

          <Divider gap={20} />

           <Flex alignItem="center" gap={10}>

            <Checkbox    {...getInputFieldProps(ESI_INPUT_FIELDS.is_including_employee_ctc.name)} color="primary" />
            <Typography variant="h6" mb={"0"}>
              {`Including employer's contribution in the CTC`}
            </Typography>
          </Flex>

          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button
              onClick={navigateToDashBoard}
              variant="outlined"
              disabled={!esiInputs.isDisableEsi}
            >
              Cancel
            </Button>

            <Button
              color="primary"
              loading={createUpdateLoading}
              onClick={handleSubmitFn}
              variant="contained"
              disabled={!esiInputs.isDisableEsi}
            >
              Save
            </Button>
          </Flex>
        </>
      ) : (
        <>
           <Card>
            <CardHeading Divider>
              <Box>
                {`Employee's`} State insurance Details
              </Box>
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleOpenStatutoryEPFModal}
                variant="filled"
                shape="box"
              />
            </CardHeading>
            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbFileText /> {/* Good for ESI Code */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    ESI Code
                  </Typography>
                  <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                    {viewESIDetails?.esi_code || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendarEvent /> {/* Good for Coverage Date */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Coverage Date
                  </Typography>
                  <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                    {getDateProperFormatForInputFn(viewESIDetails?.coverage_date) || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuilding /> {/* Good for ESI Office (Represents the office) */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    ESI Office
                  </Typography>
                  <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                    {viewESIDetails?.esi_office || "Not Assigned"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbUserDollar /> {/* Good for Employee Contribution */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employee Contribution
                  </Typography>
                  <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                    {`${viewESIDetails?.employee_contribution} % `|| "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbFileDollar /> {/* Good for Employer Contribution */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employer Contribution
                  </Typography>
                  <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                    {`${viewESIDetails?.employer_contribution} %` || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <Divider />
                <Flex gap={10}>
                  <Icon size={"lg"}>
                    <TbFileDollar />
                  </Icon>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Including {`employer's`} contribution in the CTC : {`  `}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    mb={"0"}
                    color={
                      viewESIDetails?.is_including_employee_ctc
                        ? "success"
                        : "danger"
                    }
                    textCase="capitalize"
                  >
                    {`  `}{" "}
                    {viewESIDetails?.is_including_employee_ctc ? "Yes" : "No"}
                  </Typography>
                </Flex>
              <Divider />
              </OrganizationEmDetails>
          </Card>
          <Card>
            <CardHeading Divider>
              <Box>
                ESI Address Details
              </Box>
              {(viewESIDetails?.address && viewESIDetails?.city && getStateName(viewESIDetails?.state) && viewESIDetails?.pincode)  ? 
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleOpenEPFAddressModal}
                variant="filled"
                shape="box"
              />
              :
              <FabButton
                size="sm"
                icon={<TbAddressBook />}
                onClick={handleOpenEPFAddressModal}
                variant="contained"
                shape="extended"
                color="primary"
              > Add</FabButton>
              }
            </CardHeading>

            <OrganizationEmDetails>
              {(viewESIDetails?.address && viewESIDetails?.city && getStateName(viewESIDetails?.state) && viewESIDetails?.pincode)  ? 
              <>
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbMapPin /> {/* Good for Address */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Address
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {viewESIDetails?.address || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>

                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbBuildingCommunity /> {/* Or TbBuilding, if you prefer */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      City
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {viewESIDetails?.city || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>

                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbMap2 /> {/* Good for State */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      State
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {getStateName(viewESIDetails?.state)}
                    </Typography>
                  </Box>
                </OrganizationBx>

                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbWorld /> {/* Good for Country */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Country
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {viewESIDetails?.country === "1" ? "India" : "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>

                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbCurrentLocation/> {/*Postal Code*/}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      PIN Code
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {viewESIDetails?.pincode || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>


                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbPhotoPin/> {/*Postal Code*/}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Location
                    </Typography>
                    <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                      {viewESIDetails?.location || "-"}
                    </Typography>
                  </Box>
                </OrganizationBx>




              </>
              : <>
                <Flex alignItem="center">
                <Typography variant="body2" mb={"0"}>Please enter your ESI Office Address Details for better visibility.</Typography>
                <Button color="secondary" size="sm" onClick={handleOpenEPFAddressModal}>Click here</Button> 
                </Flex>
              </>
              }
            </OrganizationEmDetails>
          </Card>
        </>
      )}
      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Employee's State insurance Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openStatutoryEPFModal}
        onClose={handleCloseStatutoryEPFModal}
        onSubmit={handleSubmitFn}
        separator
        footer={
          
          <Box mr={"auto"}>
            <Switchbox
            label={`${!esiInputs.isDisableEsi ? "Disable" : "Enable"} ESI`}
            color="Primary"
            size="lg"
            lableFirst
            checked={!esiInputs.isDisableEsi}
            onChange={handleDisableAllESIFn}
          />
            
          </Box>
        }
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              disabled={esiInputs?.isDisableEsi}
              {...getInputFieldProps(ESI_INPUT_FIELDS.esi_code.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              disabled={esiInputs?.isDisableEsi}
              {...getInputFieldProps(ESI_INPUT_FIELDS.coverage_date.name)}
              valueSinc
              onKeyDown={(e) => e.preventDefault()}
            />
          </Col>

          <Col sm={6}>
            <InputField
              disabled={!esiInputs?.isDisableEsi}
              {...getInputFieldProps(
                ESI_INPUT_FIELDS.employee_contribution.name
              )}
              valueSinc
              prefix={<VscPercentage />}
            />
          </Col>

          <Col sm={6}>
            <InputField
              disabled={!esiInputs?.isDisableEsi}
              {...getInputFieldProps(
                ESI_INPUT_FIELDS.employer_contribution.name
              )}
              valueSinc
              prefix={<VscPercentage />}
            />
          </Col>
          <Col sm={12}>
          <Checkbox
              label={"Including employer's contribution in the CTC"}
              {...getInputFieldProps(ESI_INPUT_FIELDS.is_including_employee_ctc.name)} color="primary"

            />
            </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Modal */}

      {/* Statutory-EPF-Address */}
      <Dialog
        title="ESI Address Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openEPFAddressModal}
        onClose={handleCloseEPFAddressModal}
        onSubmit={handleSubmitFn}
        separator
        
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ESI_INPUT_FIELDS.esi_office.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ESI_INPUT_FIELDS.address.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField {...getInputFieldProps(ESI_INPUT_FIELDS.city.name)} />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ESI_INPUT_FIELDS.state.name)}
              options={stateList || []}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ESI_INPUT_FIELDS.country.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ESI_INPUT_FIELDS.pincode.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ESI_INPUT_FIELDS.location.name)}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Address */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default StatutoryEsi;
